import React, { Suspense } from 'react';

const OrdersPage = React.lazy(() => import('pages/orders/list'));
const OrderDetailsPage = React.lazy(() => import('pages/orders/details'));
const NewOrderPage = React.lazy(() => import('pages/orders/new-order'));
const OrderFormPage = React.lazy(() => import('pages/order-form'));

const SimplifiedOrdersPage = React.lazy(() => import('pages/orders/simplified'));
const SimplifiedOrderDetailsPage = React.lazy(() => import('pages/orders/simplified/details'));

const OrderStatusNexternal = React.lazy(() => import('pages/order-status-nexternal'));

const ORSSessionLogsListPage = React.lazy(() => import('pages/orders/ors-session-logs/list'));
const ORSSessionLogsDetailsPage = React.lazy(() => import('pages/orders/ors-session-logs/details'));

const orderPolicies = [{ resource: 'orders', action: 'viewPage' }];
const simplifiedOrderPolicies = [{ resource: 'simplifiedOrders', action: 'view' }];

export const privateDefinitions = [
  {
    index: true,
    policies: orderPolicies,
    component: <OrdersPage />
  },
  {
    path: 'details/:orderID',
    policies: orderPolicies,
    component: <OrderDetailsPage />
  },
  {
    path: 'new',
    policies: orderPolicies,
    component: <NewOrderPage />
  },
  {
    path: 'order-forms',
    policies: [
      { resource: 'orderForm', action: 'generateOrderFormAllVendors' },
      { resource: 'orderForm', action: 'generateOrderFormOwnVendors' }
    ],
    component: <OrderFormPage />
  },
  {
    path: 'ors-session-logs',
    policies: orderPolicies,
    component: <ORSSessionLogsListPage />
  },
  {
    path: 'ors-session-logs/details/:sessionLogID',
    policies: orderPolicies,
    component: <ORSSessionLogsDetailsPage />
  },
  {
    path: 'simplified',
    policies: simplifiedOrderPolicies,
    component: <SimplifiedOrdersPage />
  },
  {
    path: 'simplified/details/:orderID',
    policies: simplifiedOrderPolicies,
    component: <SimplifiedOrderDetailsPage />
  }
];

export const publicDefinitions = [
  {
    path: 'status',
    component: <OrderStatusNexternal />
  }
];
